export default ({
  userRepository,
}) => async (token) => userRepository.getInfoByToken(token);
